export default {
    content: {
        items: {
            'dash-board': {
                text: "Dashboard",
                icon: "yc-icon-dashboard",
                childrenPath: "/dashboard",
            },
            application: {
                text: "Application",
                icon: "yc-icon-list",
                childrenPath: "/application",
            },
            'change-password': {
                text: "Change password",
                icon: "yc-icon-password",
                childrenPath: "/change-password",
            },
            'mfa-management': {
                text: "MFA",
                icon: "yc-icon-mfa",
                childrenPath: "/mfa-management",
            },
            'ssh-server': {
                text: "SSH Servers",
                icon: "yc-icon-list",
                childrenPath: "/ssh-server",
            },
            'assign-request': {
                text: "Assign requests",
                icon: "yc-icon-assign-request",
                childrenPath: "/assign-request",
            },
        }
    }
}
